import React from 'react';
import { ICirclesGroup } from '../../../redux/layers/layerTypes';

import { makeStyles, createStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';
import { Typography } from '@material-ui/core';

type CircularProps = {
  style: ICirclesGroup;
};

function Circle({ style }: CircularProps) {
  // We are assuming the max size here
  const size = style.circles ? style.circles[0].radius * 2 : 0;
  const classes = useStyles({ size: size });

  return (
    <div>
      {style.title && (
        <Typography
          className={classes.title}
          color="textPrimary"
          variant="subtitle2">
          {style.title}
        </Typography>
      )}
      <div
        className={classes.circleContainer}
        style={{
          width: size,
          height: size
        }}>
        {style.circles &&
          style.circles.map((circle, idx) => (
            <div
              className={classes.circle}
              key={idx}
              style={{
                width: circle.radius * 2,
                height: circle.radius * 2,
                ...circle.styles
              }}>
              <Typography
                className={classes.label}
                color="textPrimary"
                variant="caption"
                style={{
                  paddingLeft: size * 0.5 + 10,
                  left: circle.radius
                }}>
                {circle.label}
              </Typography>
            </div>
          ))}
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      marginBottom: 5,
      fontSize: 11
    },
    label: {
      fontSize: 10,
      position: 'absolute',
      top: -9,
      // ToDo better to make width not hard coded
      width: 100,
      '&::before': {
        display: 'block',
        content: "''",
        position: 'absolute',
        left: 0,
        top: 8,
        height: 0,
        width: (props: { size: number }) => props.size * 0.5 + 5,
        borderTop: `1px dashed ${theme.palette.text.primary}`
      }
    },
    circleContainer: {
      position: 'relative',
      marginTop: 5
    },
    circle: {
      boxSizing: 'border-box',
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      marginLeft: 'auto',
      marginRight: 'auto',
      border: `1px solid ${theme.palette.text.primary}`,
      borderRadius: '50%'
    }
  })
);

export default Circle;
